import { isly } from "isly";
import { Hour as TimeHour } from "./Hour";
import { Millisecond as TimeMillisecond } from "./Millisecond";
import { Minute as TimeMinute } from "./Minute";
import { Numeric as TimeNumeric } from "./Numeric";
import { Precision as TimePrecision } from "./Precision";
import { Second as TimeSecond } from "./Second";
export var Time;
(function (Time) {
    var _a;
    Time.Hour = TimeHour;
    Time.Millisecond = TimeMillisecond;
    Time.Minute = TimeMinute;
    Time.Numeric = TimeNumeric;
    Time.Precision = TimePrecision;
    Time.Second = TimeSecond;
    _a = isly
        .string((value) => {
        const splitted = /^\d{2}(?::\d{2}(?::\d{2}(?:\.\d{3})?)?)?$/.test(value) && Time.split(value);
        return (splitted &&
            Time.Hour.type.is(splitted[0]) &&
            Time.Minute.type.optional().is(splitted[1]) &&
            Time.Second.type.optional().is(splitted[2]) &&
            Time.Millisecond.type.optional().is(splitted[3]) &&
            (splitted[2] != "60" || (splitted[0] == "23" && splitted[1] == "59")));
    }, "HH[:mm[:ss[.fff]]]")
        .rename("isoly.Time")
        .describe("ISO 8601 time in the format HH[:mm[:ss[.fff]]].")
        .bind(), Time.type = _a.type, Time.is = _a.is, Time.flawed = _a.flawed;
    function create(time, precision = "seconds") {
        return typeof time == "number" ? create(Time.Numeric.create(time, precision)) : Time.Numeric.format(time);
    }
    Time.create = create;
    function split(value) {
        const [hours, minutes, secondsMilliseconds] = value.split(":", 3);
        const [seconds, milliseconds] = secondsMilliseconds?.split(".", 2) ?? [undefined, undefined];
        return [
            hours.padStart(2, "0"),
            minutes?.padStart(2, "0"),
            seconds?.padStart(2, "0"),
            milliseconds?.slice(0, 3)?.padEnd(3, "0"),
        ];
    }
    Time.split = split;
    function normalize(time, precision) {
        return Time.Numeric.format(Time.Numeric.parse(time), precision);
    }
    Time.normalize = normalize;
})(Time || (Time = {}));
//# sourceMappingURL=index.js.map